/* Coiny Minds v5: purposeful, progressively enhanced product discovery. */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const choices = {
    save: { number:'01', title:'Choose a savings goal.', description:'Choose something your child would like to save for. Add money, count it together and return another day to see the progress.', question:'“What would you like to save for?”' },
    spend: { number:'02', title:'Compare two choices.', description:'Talk about two things your child wants. Compare what they cost and decide which matters more to them today.', question:'“Which would you choose, and why?”' },
    donate: { number:'03', title:'Decide who to help.', description:'Choose a person or cause you care about together. Set money aside and talk about other ways to help, too.', question:'“Who would you like to help?”' },
    invest: { number:'04', title:'Talk about the future.', description:'Use this compartment to start a conversation about investing. A grown-up can explain that investments may grow or lose value; the bank itself only stores money.', question:'“What could we plan for in the future?”' }
  };
  function init(root) {
    root.querySelectorAll('[data-cm-discover]:not([data-cm-discover-ready])').forEach(section => {
      section.dataset.cmDiscoverReady = 'true';
      section.classList.add('cm-discover-enhanced');
      const buttons = [...section.querySelectorAll('[data-cm-choice]')];
      const panel = section.querySelector('.cm-v5-choice-panel');
      let panelAnimation;
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        const choice = choices[button.dataset.cmChoice];
        if (!choice || button.getAttribute('aria-pressed') === 'true') return;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelector('[data-cm-choice-kicker]').textContent = `${choice.number} / ${button.dataset.cmChoice.toUpperCase()}`;
        section.querySelector('[data-cm-choice-title]').textContent = choice.title;
        section.querySelector('[data-cm-choice-description]').textContent = choice.description;
        section.querySelector('[data-cm-choice-question]').textContent = choice.question;
        section.dataset.cmActiveChoice = button.dataset.cmChoice;
        panelAnimation?.cancel();
        if (!reduced.matches && panel.animate) {
          panelAnimation = panel.animate([{transform:'translateY(8px)',opacity:.65},{transform:'translateY(0)',opacity:1}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)'});
        }
      }));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  // Entrance motion never hides content or delays a shopping control.
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (!reduced.matches && entry.target.animate) entry.target.animate([{transform:'translateY(10px)'},{transform:'translateY(0)'}],{duration:400,easing:'cubic-bezier(.2,.7,.2,1)'});
    }),{threshold:.15});
    const observe = root => root.querySelectorAll('[data-cm-reveal]').forEach(el => {if(el.getBoundingClientRect().top > innerHeight) observer.observe(el);});
    observe(document);
    document.addEventListener('shopify:section:load', e => observe(e.target));
    reduced.addEventListener?.('change', e => {if(e.matches) document.getAnimations?.().forEach(a => a.cancel());});
  }
})();
